(function(){'use strict';
var root=document.querySelector('[data-np]');if(!root||root.dataset.npInit)return;root.dataset.npInit='1';document.body.classList.add('np-page');
var C=window.NPCore,R=window.NPRender,ids=JSON.parse(root.dataset.variants).map(String),nativeFetch=window.fetch.bind(window),form=null,
 dialog=document.querySelector('[data-np-dialog]'),zoom=dialog.querySelector('[data-np-zoom]'),status=root.querySelector('[data-np-status]'),
 preview=root.querySelector('[data-np-preview]'),namesBox=root.querySelector('[data-np-names]'),latest=null,busy=false,token=0,assetsP=null,kept=[];
var dock=document.createElement('div');dock.className='np-dock';dock.hidden=true;
var thumb=document.createElement('img');thumb.alt='Personalized pajama pants preview';
var dockBtn=document.createElement('button');dockBtn.type='button';dockBtn.className='np-preview';dockBtn.textContent='Preview';
dock.append(thumb,dockBtn);document.body.appendChild(dock);

// ---------------------------------------------------------------- state
function radio(k){return Array.from(root.querySelectorAll('[data-np-in="'+k+'"]')).find(function(x){return x.checked;});}
function nameInputs(){return Array.from(root.querySelectorAll('[data-np-name]'));}
function values(){
 var bg=radio('bg'),cnt=radio('count'),t=root.querySelector('[data-np-in="title"]');
 return {bg:bg?bg.value:'',title:t?t.value:'',count:cnt?cnt.value:'',names:nameInputs().map(function(i){return i.value;})};
}
function missing(){return C.missing(values());}
function field(key){return root.querySelector('[data-np-g="'+key+'"]');}
function warning(){
 var miss=missing(),label={bg:'Background Color',title:'Custom Title',count:'Number Of Names'};
 ['bg','title','count'].forEach(function(k){
  var g=field(k),err=g.querySelector('.np-error'),bad=miss.indexOf(k)>=0;
  err.hidden=!bad;err.textContent=bad?label[k]+' is required':'';
  g.querySelectorAll('input').forEach(function(i){i.setAttribute('aria-invalid',String(bad));});
 });
 nameInputs().forEach(function(inp,i){
  var g=inp.closest('.np-g'),err=g.querySelector('.np-error'),bad=miss.indexOf('name'+i)>=0;
  err.hidden=!bad;err.textContent=bad?'Custom Name #'+(i+1)+' is required':'';inp.setAttribute('aria-invalid',String(bad));
 });
 if(miss.length){
  var first=miss[0],el=/^name\d+$/.test(first)?nameInputs()[+first.slice(4)].closest('.np-g'):field(first),focus=el.querySelector('input');
  if(focus)focus.focus({preventScroll:true});
  var header=document.querySelector('.header-v18__sticky,header'),bottom=header?Math.max(0,Math.min(220,header.getBoundingClientRect().bottom)):120;
  window.scrollTo({top:Math.max(0,el.getBoundingClientRect().top+window.scrollY-bottom-20),behavior:'smooth'});
 }
 return miss.length===0;
}
function target(f){return !!(f&&ids.indexOf(String((f.querySelector('[name="id"]')||{}).value))>=0);}

// ---------------------------------------------------------------- dynamic name fields
function buildNames(){
 var n=parseInt((radio('count')||{}).value,10)||0,cur=nameInputs();
 cur.forEach(function(i,k){kept[k]=i.value;});
 namesBox.textContent='';
 for(var i=0;i<n;i++){
  var g=document.createElement('fieldset');g.className='np-g';g.dataset.npNameG=String(i);
  g.innerHTML='<legend><label for="np-name-'+i+'">Custom Name #'+(i+1)+' <i>*</i></label></legend><div class="np-text-wrap"><input id="np-name-'+i+'" type="text" maxlength="'+C.NAME_MAX+'" data-np-name="'+i+'" aria-required="true" autocomplete="off"><span class="np-count">0/'+C.NAME_MAX+'</span></div><small>Example: Jennifer</small><p class="np-error" role="alert" hidden></p>';
  var inp=g.querySelector('input');inp.value=kept[i]||'';g.querySelector('.np-count').textContent=inp.value.length+'/'+C.NAME_MAX;
  namesBox.appendChild(g);
 }
}

// ---------------------------------------------------------------- theme glue (same behaviour as the other custom pants pages)
function relocate(){
 var f=Array.from(document.querySelectorAll('form[action*="/cart/add"]')).find(function(x){return target(x)&&(x.closest('.xo-product-info-content')||x.querySelector('.buy-button__add'));});
 if(!f)return;form=f;form.classList.add('np-form');
 var wrap=f.querySelector('#kai-cf');if(!wrap){wrap=document.createElement('div');wrap.id='kai-cf';f.insertBefore(wrap,f.firstChild);}
 if(root.parentNode!==wrap)wrap.appendChild(root);
 var quantity=f.querySelector('.buy-button xo-cart-quantity');
 if(quantity&&!quantity.parentElement.classList.contains('np-quantity')){quantity.parentElement.classList.add('np-quantity');var label=document.createElement('span');label.textContent='Quantity';quantity.parentElement.insertBefore(label,quantity);}
 document.querySelectorAll('.pp-step-head').forEach(function(h){var guide=h.querySelector('xo-modal-trigger[xo-name="show-sizeguide"]');if(guide)h.before(guide);h.remove();});
 document.querySelectorAll('[data-cnf]').forEach(function(x){x.hidden=true;x.querySelectorAll('input,select,textarea').forEach(function(i){i.disabled=true;});});
}
// hidden mirrors so sticky add-to-cart forms carry the same properties
function sync(){
 var s=values(),p={};try{p=C.props(s);}catch(e){p={};if(s.bg)p['Background Color']=s.bg;if(C.clean(s.title))p['Custom Title']=C.clean(s.title);}
 document.querySelectorAll('form[action*="/cart/add"]').forEach(function(f){
  if(!target(f)||f.contains(root))return;
  Array.from(f.querySelectorAll('input[data-np-mirror]')).forEach(function(i){if(!(i.dataset.npMirror in p))i.remove();});
  Object.keys(p).forEach(function(k){
   var i=Array.from(f.querySelectorAll('input[data-np-mirror]')).find(function(x){return x.dataset.npMirror===k;});
   if(!i){i=document.createElement('input');i.type='hidden';i.name='properties['+k+']';i.dataset.npMirror=k;f.appendChild(i);}
   i.value=p[k];
  });
 });
}

// ---------------------------------------------------------------- assets + preview
function loadImage(src){return new Promise(function(resolve,reject){var im=new Image();im.onload=function(){resolve(im);};im.onerror=function(){reject(Error('Preview image unavailable'));};im.src=src;});}
function pixels(im){var c=document.createElement('canvas');c.width=im.width;c.height=im.height;var ctx=c.getContext('2d',{willReadFrequently:true});ctx.drawImage(im,0,0);return ctx.getImageData(0,0,im.width,im.height).data;}
// Codex-drawn sticker icons (atlas) for the pattern and the colour swatches; the renderer falls back to vector icons if this fails
var iconsP=nativeFetch(root.dataset.icons).then(function(r){if(!r.ok)throw Error('icons');return r.json();}).then(function(j){return loadImage('data:image/webp;base64,'+j.webp).then(function(im){R.setIcons(im,j.cell,j.cols);});}).catch(function(){});
function assets(){
 // supplier PSD mockup maps (front + back pants): per view uv / leg / base / gain images, decoded to RGBA arrays
 if(!assetsP){
  assetsP=iconsP.then(function(){return nativeFetch(root.dataset.mock);}).then(function(r){if(!r.ok)throw Error('Preview asset unavailable');return r.json();}).then(function(j){
   return Promise.all(j.views.map(function(v){
    return Promise.all(['uv','leg','base','gain'].map(function(k){return loadImage('data:image/webp;base64,'+v[k]).then(pixels);})).then(function(a){
     return {w:v.w,h:v.h,dx:v.dx,dy:v.dy,ps:v.ps,legs:v.legs,v:v.v,uv:a[0],leg:a[1],base:a[2],gain:a[3]};
    });
   })).then(function(views){return {S:j.size,DW:j.design[0],DH:j.design[1],views:views};});
  });
  assetsP.catch(function(){assetsP=null;});
 }
 return assetsP;
}
function selection(){
 var s=values(),idx=C.BG.indexOf(s.bg),names=s.names.map(C.clean).filter(Boolean);
 return {bg:idx<0?0:idx,title:s.title,names:names};
}
function firstImages(){
 var list=[];
 document.querySelectorAll('xo-gallery xo-carousel').forEach(function(car){
  var slides=Array.from(car.querySelectorAll('xo-carousel-slide')),main=slides.filter(function(s){return !s.closest('xo-carousel-thumbnail');}),th=slides.filter(function(s){return s.closest('xo-carousel-thumbnail');});
  [main[0],th[0]].forEach(function(s){if(s)s.querySelectorAll('img').forEach(function(im){if(list.indexOf(im)<0)list.push(im);});});
 });
 document.querySelectorAll('img[data-np-first]').forEach(function(im){if(list.indexOf(im)<0)list.push(im);});
 return list;
}
function setGallery(url){
 firstImages().forEach(function(im){
  if(!im.dataset.npFirst){im.dataset.npFirst='1';im.dataset.npOrig=im.getAttribute('src')||'';im.dataset.npSrcset=im.getAttribute('srcset')||'';im.dataset.npSizes=im.getAttribute('sizes')||'';im.dataset.npAlt=im.alt;}
  im.removeAttribute('srcset');im.removeAttribute('sizes');im.src=url;im.alt='Personalized names pajama pants — front view';im.style.cursor='zoom-in';
 });
 zoom.src=url;thumb.src=url;
}
function restore(){
 latest=null;
 firstImages().forEach(function(im){
  if(!im.dataset.npOrig)return;
  im.src=im.dataset.npOrig;if(im.dataset.npSrcset)im.setAttribute('srcset',im.dataset.npSrcset);if(im.dataset.npSizes)im.setAttribute('sizes',im.dataset.npSizes);im.alt=im.dataset.npAlt;
 });
}
function showFirstSlide(){
 try{
  var im=firstImages().find(function(x){return x.closest('xo-carousel')&&x.offsetParent!==null&&!x.closest('xo-carousel-thumbnail');});if(!im)return;
  var slide=im.closest('xo-carousel-slide'),car=slide.closest('xo-carousel');
  var th=Array.from(document.querySelectorAll('xo-carousel-thumbnail')).find(function(x){return x.offsetParent!==null;});
  if(th&&window.innerWidth>=750){var first=th.querySelector('xo-carousel-slide');if(first)first.click();}
  var prev=car.querySelector('xo-carousel-prev'),guard=0;
  (function step(){if(slide.hasAttribute('xo-active')||!prev||guard++>12)return;prev.click();setTimeout(step,120);})();
 }catch(e){}
}
var canvas=document.createElement('canvas'),tileCanvas=document.createElement('canvas');canvas.width=canvas.height=1024;
function run(open){
 var my=++token;status.textContent='Updating your preview…';
 return assets().then(function(A){
  if(my!==token)return;
  var start=performance.now(),sel=selection(),T=R.tile(A,sel,tileCanvas,1);
  canvas.getContext('2d').putImageData(new ImageData(R.render(A,sel,T),1024,1024),0,0);
  latest=canvas.toDataURL('image/jpeg',.94);root.dataset.renderMs=String(Math.round(performance.now()-start));
  setGallery(latest);showFirstSlide();status.textContent=missing().length?'':'Preview updated.';
  if(open&&!dialog.open)dialog.showModal();refreshDock();
 }).catch(function(){if(my!==token)return;restore();status.textContent='Preview could not load. Tap Preview to retry.';});
}
function openPreview(){clearTimeout(timer);if(warning())run(true);}
preview.addEventListener('click',openPreview);dockBtn.addEventListener('click',openPreview);thumb.addEventListener('click',openPreview);
dialog.querySelectorAll('[data-np-close]').forEach(function(b){b.addEventListener('click',function(){dialog.close();});});
dialog.addEventListener('click',function(e){if(e.target!==dialog)return;var r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();});
dialog.addEventListener('close',refreshDock);
function refreshDock(){
 var r=root.getBoundingClientRect(),p=preview.getBoundingClientRect(),show=window.innerWidth<750&&!dialog.open&&r.top<window.innerHeight&&r.bottom>0&&p.top>=window.innerHeight;
 dock.hidden=!show;document.body.classList.toggle('np-dock-visible',show);
}
var frame;function queueDock(){cancelAnimationFrame(frame);frame=requestAnimationFrame(refreshDock);}
window.addEventListener('scroll',queueDock,{passive:true});window.addEventListener('resize',queueDock);

// ---------------------------------------------------------------- input handling
var timer;
function changed(e){
 var i=e.target;
 if(i.matches('[data-np-in="count"]'))buildNames();
 else if(i.matches('[data-np-in="title"]')){i.value=i.value.slice(0,C.TITLE_MAX);root.querySelector('[data-np-count="title"]').textContent=i.value.length+'/'+C.TITLE_MAX;}
 else if(i.matches('[data-np-name]')){i.value=i.value.slice(0,C.NAME_MAX);i.closest('.np-g').querySelector('.np-count').textContent=i.value.length+'/'+C.NAME_MAX;}
 else if(!i.matches('[data-np-in]'))return;
 var g=i.closest('.np-g');
 if(g){var err=g.querySelector('.np-error');if(err&&((i.type==='radio'&&i.checked)||(i.type!=='radio'&&i.value.trim().length))){err.hidden=true;i.setAttribute('aria-invalid','false');}}
 sync();clearTimeout(timer);timer=setTimeout(function(){run(false);},90);
}
root.addEventListener('input',changed);root.addEventListener('change',changed);

// ---------------------------------------------------------------- cart
function fromParams(fd){
 var item={id:fd.get('id'),quantity:fd.get('quantity')||1,properties:{}};
 fd.forEach(function(v,k){var m=k.match(/^properties\[(.+)\]$/);if(m)item.properties[m[1]]=v;});
 if(fd.get('selling_plan'))item.selling_plan=fd.get('selling_plan');
 var p={items:[item]};['sections','sections_url'].forEach(function(k){if(fd.get(k))p[k]=fd.get(k);});return p;
}
function fromForm(f){return fromParams(new FormData(f));}
function isScoped(payload){return (payload.items||[payload]).some(function(i){return ids.indexOf(String(i.id))>=0;});}
function withProps(p){return C.apply(p,values(),ids);}
// The theme's own add-to-cart runs (so the mini cart opens as on every other product); our fetch patch below
// validates and injects the properties. Here we only block an incomplete form.
document.addEventListener('click',function(e){
 var b=e.target.closest&&e.target.closest('.buy-button__add button,xo-cart-add,.sticky-addcart__add,[name="add"],[data-add-to-cart]');if(!b)return;
 var f=b.closest('form');if(f&&!target(f))return;
 if(!f){var product=b.closest('xo-product');if(!b.closest('.sticky-addcart')&&(!product||String(product.getAttribute('xo-product-id'))!==root.dataset.product))return;}
 if(!warning()){e.preventDefault();e.stopImmediatePropagation();}
},true);
document.addEventListener('submit',function(e){if(!target(e.target)||!/\/cart\/add/.test(e.target.action))return;if(!warning()){e.preventDefault();e.stopImmediatePropagation();}},true);
document.addEventListener('click',function(e){var im=e.target.closest&&e.target.closest('img[data-np-first]');if(im&&latest&&!im.closest('xo-carousel-thumbnail')){e.preventDefault();e.stopImmediatePropagation();openPreview();}},true);
// scope the network guard to this product (covers AJAX adds from the sticky bar too)
window.fetch=async function(u,init){
 var url=typeof u==='string'?u:u&&u.url||'';
 if(!/\/cart\/add(?:[.?/]|$)/.test(url))return nativeFetch(u,init);
 var body=init&&init.body,request=typeof Request!=='undefined'&&u instanceof Request;
 if(body===undefined&&request)body=await u.clone().text();
 var payload=null;
 try{if(typeof body==='string'){if(body.trim().charAt(0)==='{')payload=JSON.parse(body);else{var pars=new URLSearchParams(body);if(pars.has('id'))payload=fromParams(pars);}}else if(body instanceof FormData||body instanceof URLSearchParams){payload=fromParams(body);}}catch(e){}
 if(!payload||!isScoped(payload))return nativeFetch(u,init);
 if(!warning())throw Error('Please complete your personalization.');
 var bundled=withProps(payload),headers=new Headers(init&&init.headers||(request?u.headers:undefined));headers.set('Content-Type','application/json');
 var options=Object.assign({},init,{method:init&&init.method||(request?u.method:'POST'),headers:headers,body:JSON.stringify(bundled)});
 return nativeFetch(request?u.url:u,options);
};

// ---------------------------------------------------------------- boot
iconsP.then(function(){root.querySelectorAll('[data-np-swatch]').forEach(function(c){R.swatch(+c.dataset.npSwatch,c,80);});});
buildNames();
if(R.fontReady)R.fontReady.then(function(){if(latest)run(false);});
relocate();sync();
var mutationTimer;new MutationObserver(function(){clearTimeout(mutationTimer);mutationTimer=setTimeout(function(){relocate();sync();if(latest)setGallery(latest);},100);}).observe(document.body,{childList:true,subtree:true});
assets().catch(function(){});refreshDock();
// keep the gallery under the sticky header
var gallery=document.querySelector('.xo-product-info-media-style3'),header=document.querySelector('.header-v18__sticky,xo-animate.xo-header')||document.querySelector('header');
if(gallery&&header){var lastTop=null;gallery.style.transition='top .15s ease';
 var sticky=function(){var t=window.innerWidth>=750?Math.round(Math.max(16,Math.min(220,header.getBoundingClientRect().bottom+16))):null;if(t!==lastTop){lastTop=t;gallery.style.top=t===null?'':t+'px';}};
 window.addEventListener('scroll',sticky,{passive:true});window.addEventListener('resize',sticky);setInterval(sticky,100);sticky();}
})();
